import classNames from 'classnames';
import React, { AnchorHTMLAttributes, Component, PropsWithChildren, KeyboardEvent } from 'react';
import { NavItemContent } from './NavItemContent';
import { INavItemProps } from './types';

export class NavItem extends Component<PropsWithChildren<INavItemProps>, {}> {
  public static defaultProps = {
    active: false,
    disabled: false,
  };

  public handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (this._selectItem()) {
      e.preventDefault();
    } else {
      const { onClick } = this.props;
      onClick && onClick(e);
    }
  };

  public handleEnter = (event: KeyboardEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const isEnterKey = event.keyCode === 13;
    isEnterKey && this._selectItem();
  };

  public _selectItem() {
    const { disabled, eventKey, onSelect } = this.props;
    if (onSelect && eventKey) {
      !disabled && onSelect(eventKey);
      return true;
    } else {
      return false;
    }
  }

  public render() {
    const {
      onClick,
      onSelect,
      eventKey,
      active,
      disabled,
      tooltip,
      children,
      NavContent = NavItemContent,
      ...otherprops
    } = this.props;
    const props: AnchorHTMLAttributes<HTMLAnchorElement> = {
      href: otherprops.href,
      role: otherprops.role,
    };
    const navContentProps = { eventKey, active, disabled };

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
      props.tabIndex = 0;
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = { pointerEvents: 'none', ...props.style };
    }

    return (
      <li
        role="presentation"
        className={classNames('menu__item', {
          active,
          disabled,
          'menu__item--current': active,
        })}
        title={tooltip}
      >
        <a {...props} className={'menu__link'} onClick={this.handleClick} onKeyUp={this.handleEnter}>
          <NavContent {...navContentProps}>{this.props.children}</NavContent>
        </a>
      </li>
    );
  }
}

export default NavItem;
